import React from 'react';
import styled from 'styled-components';
import type { TableCell } from '~/components/organism/Table/types';
import { cellProps } from '~/components/organism/Table/utils/propGetters';
import Checkbox from '~/components/molecule/Checkbox';

type Props = {
  cell: TableCell<any>;
  value: boolean;
  disabled?: boolean;
  onChange: () => void;
};

const CheckboxColumnCell: React.FCC<Props> = ({
  cell,
  onChange,
  value,
  disabled,
}) => {
  const tdCellProps = cell.getCellProps(cellProps);

  return (
    <StyledTd {...tdCellProps}>
      <CellContainer>
        <Checkbox
          value={value}
          name="selectRowCheckbox"
          disabled={disabled}
          large
          onChange={onChange}
        />
      </CellContainer>
    </StyledTd>
  );
};

const CellContainer = styled.div<{}>``;

const StyledTd = styled.div<{}>`
  cursor: default;
`;

export default CheckboxColumnCell;
